export default function accountMenuToggle () {
  const elAccountMenu = document.querySelector('.menu-item--account')

  if (elAccountMenu) {
    const elAccountMenuToggle = elAccountMenu.querySelector('a')

    elAccountMenuToggle.addEventListener('click', (evt) => {
      evt.preventDefault()
      const elSubMenu = elAccountMenu.querySelector('.sub-menu')

      elAccountMenu.classList.toggle('menu-item--open')
      elSubMenu.classList.toggle('sub-menu--open')
    })
  }
}
